/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

export default class ExhibitionUsers extends Component {
  render() {
    const { id, buttonPosition, buttonColor, title, url } = this.props;

    const params = new URLSearchParams(window.location.search);
    let header = '';
    if (params.get('header') === 'false') {
      header = '&header=false';
    }

    return (
      <div
        className={`tile__exhibition ${buttonPosition}`}
        style={{ borderColor: buttonColor }}
      >
        <Link
          to={`/main/hotel-showroom/${url}?id=${id}${header}`}
          style={{ color: buttonColor }}
        >
          <div className='tile-holder' style={{ color: buttonColor }}>
            <div className='title' style={{ color: buttonColor }}>
              <div className='icon' />
              {title === 'North America (9)' && <span>The Americas (9)</span>}
              {title !== 'North America (9)' && <span>{title}</span>}
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

ExhibitionUsers.propTypes = {
  id: PropTypes.number.isRequired,
  buttonPosition: PropTypes.string,
  buttonColor: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

ExhibitionUsers.defaultProps = {
  buttonPosition: '',
  buttonColor: '',
  title: '',
  url: '',
};
